import React from "react";
import { BiMoveVertical } from "react-icons/bi";

export default function StaticItem({ field }) {
  const ui = field["x-ui"];
  const title = field.title || "(Sans titre)";

  return (
    <div className="bg-light-subtle border rounded p-2 mb-2 d-flex gap-2 align-items-start">

      {/* Drag Handle (affiché, mais réel drag géré par wrapper Pangea) */}
      <span className="text-muted" style={{ cursor: "grab" }}>
        <BiMoveVertical size={18} />
      </span>

      <div className="flex-grow-1">
        {/* Label */}
        <div className="d-flex flex-column">
          <span className="fw-semibold">• {title}</span>
          <code className="small text-muted ms-0">{ui}:{field.name}</code>
        </div>

        {/* Contenu selon le type */}
        <div className="mt-2 small">
          {ui === "staticText" && (
            <div className="text-muted">
              {field.content || "Texte statique vide…"}
            </div>
          )}

          {ui === "staticTitle" && (
            <div className="fw-bold">
              {field.content || "Titre statique"}
            </div>
          )}

          {ui === "separator" && <hr className="my-2" />}
        </div>
      </div>

    </div>
  );
}
